/**
 * Created on 14/07/2021.
 */
import App from 'app/app.js';
import { FlightRecorderService } from '@app/service/FlightRecorderService';

// Redirect based on product catalog as well as type of job eg. ENHANCED_PAYONLY / PAYONLY
function RedirectionService(ProductCatalogStore, JobStore, ErrorLogService, FlightRecorderService, $injector) {
  this.routeNext = function (routeParams) {
    routeParams = routeParams || {};
    var RouterService = $injector.get('RouterService');
    const { redirectedSmartUrlRoute } = RouterService;
    if (redirectedSmartUrlRoute?.path.includes('/package/')) {
      RouterService.goToPackages();
    } else if (redirectedSmartUrlRoute?.path.includes('/addon/')) {
      RouterService.goToAddOn();
    } else if (routeParams.routeTo === 'ENHANCED_PAYONLY' || JobStore.isEnhancedPayOnly()) {
      RouterService.goToEnhancedPayOnly();
    } else if (routeParams.routeTo === 'PAYONLY' || JobStore.isPayOnly()) {
      RouterService.goToPayOnly();
    } else if (!routeParams.skipMyProofs && (JobStore.isReorder() || JobStore.isProofOrder())) {
      RouterService.goToMyProofs();
    } else if (ProductCatalogStore.containsPackage()) {
      RouterService.goToPackages();
    } else if (ProductCatalogStore.containsCyop()) {
      RouterService.goToCYOP();
    } else if (ProductCatalogStore.containsAddOn()) {
      RouterService.goToAddOn();
    } else if (ProductCatalogStore.containsBundle()) {
      RouterService.goToSpecialOffers();
    } else {
      ErrorLogService(
        new Error(
          `Redirection error: No valid package, addon or bundle found. Ensure that the product catalog contains at least one of the following: packages, addOns, bundles. FR: ${FlightRecorderService.records()}`
        )
      );
      FlightRecorderService.clear();
    }
  };
}

App.service('RedirectionService', [
  'ProductCatalogStore',
  'JobStore',
  'ErrorLogService',
  'FlightRecorderService',
  '$injector',
  RedirectionService
]);
